import styles from "./Hero.module.less";

export const HeroCol = ({ children }) => {
  return <div className={styles.HeroCol}>{children}</div>;
};
